import React, { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { useAtom as useSegment } from 'jotai';
import styles from './MainLayout.module.css';
import KnowledgeCenterIcon from '../../atoms/KnowledgeCenterIcon';
import ModalComponent from '../../molecules/ModalComponent';
import ImageGenerationFields from '../../widgets/ImageGeneration/index';
import { ImageGenerationModalAtom } from '../../../store/markettingContentGeneration/stateSegments/ImageGenerationModalStateSegment';
import { PAGE_ROUTES } from '../../../constants/common';

type MainLayoutProps = {
  children: React.ReactNode;
};

/**
 * MainLayout - Content wrapper for the main application area
 *
 * Handles the main content area rendering.
 * Note: The sidebar and global modals (Knowledge Center, Content Rules)
 * are rendered by RootLayout using the shared Sidebar component.
 */
const MainLayout: FC<MainLayoutProps> = ({ children }) => {
  const location = useLocation();
  const [ImageGenerationModalState, setImageGenerationModalState] = useSegment(
    ImageGenerationModalAtom
  );

  const { isImageGenerationModalOpen } = ImageGenerationModalState;

  // Fixed sidebar width (no longer collapsible)
  const sidebarWidth = 80;

  // Only show top-nav on generate-content route
  const isGenerateContentRoute = location.pathname.startsWith(
    PAGE_ROUTES.GENERATE_CONTENT
  );

  return (
    <div className='h-full flex flex-col overflow-hidden'>
      {isGenerateContentRoute && (
        <div id='top-nav' className={styles['top-nav']} />
      )}
      <div className='flex-1 min-h-0 overflow-hidden'>{children}</div>
      {isImageGenerationModalOpen && (
        <ModalComponent
          className={styles.knowledgeCenterModal}
          isOpen={isImageGenerationModalOpen}
          onClose={() => {
            setImageGenerationModalState(prev => ({
              ...prev,
              isImageGenerationModalOpen: false,
            }));
          }}
          title='Image Generation'
          headerIcon={<KnowledgeCenterIcon />}
          leftOffset={sidebarWidth}
          headerStyle={styles.knowledgeCenterModal__header}
        >
          <ImageGenerationFields />
        </ModalComponent>
      )}
    </div>
  );
};

MainLayout.displayName = 'MainLayout';
export default MainLayout;
